export const clipboardFolderUrl = (path: string, ownerId?: string | null): string => {
  if (!path) return "/clipboard";
  const encodedPath = path.split("/").map(encodeURIComponent).join("/");
  const owner = ownerId ? `?owner=${encodeURIComponent(ownerId)}` : "";
  return `/clipboard/folder/${encodedPath}${owner}`;
};

export const clipboardSearchUrl = (searchId: string): string =>
  `/clipboard/search/${encodeURIComponent(searchId)}`;

export const clipboardDocumentUrl = (
  documentId: string,
  folderPath: string,
  ownerId?: string | null,
  searchId?: string,
  childPath = "",
): string => {
  const child = childPath
    ? `/${childPath.split("/").map(encodeURIComponent).join("/")}`
    : "";
  if (searchId) {
    return `/clipboard/search/${encodeURIComponent(searchId)}/document/${encodeURIComponent(documentId)}${child}`;
  }
  const params = new URLSearchParams();
  if (folderPath) params.set("folder", folderPath);
  if (ownerId) params.set("owner", ownerId);
  const query = params.toString();
  return `/clipboard/document/${encodeURIComponent(documentId)}${child}${query ? `?${query}` : ""}`;
};
